import { PostHogProvider as PHProvider } from "@posthog/react";
import { initPostHog, getPostHogClient } from "./client";
import { isPostHogEnabled } from "./config";
import PostHogPageView from "./PostHogPageView";

// Initialize as early as the module loads (browser bundle only).
initPostHog();

/**
 * App-level PostHog provider.
 * Wraps children with the official React provider and mounts the
 * React Router pageview tracker.
 */
const PostHogProvider = ({ children }) => {
  if (!isPostHogEnabled) {
    return children;
  }

  return (
    <PHProvider client={getPostHogClient()}>
      <PostHogPageView />
      {children}
    </PHProvider>
  );
};

export default PostHogProvider;
